import { defineComponent, h } from 'vue';
import { chakra } from '@chakra-ui/vue-system';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CAccordion = defineComponent({
  props: {
    as: {
      type: [String],
      "default": "div"
    }
  },
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        attrs = _ref.attrs;
    return function () {
      return h(chakra(props.as, {
        label: "accordion"
      }), _extends({}, attrs), slots);
    };
  }
});

export { CAccordion as default };
